/* Use the same available, device/design-matched bundle contents as the PDP. */
(() => {
  const id = (value) => String(value || '');
  const recommendationKey = (item) => /^spidersaver(?:-|$)/i.test(item.productHandle || '')
    || /^spidersaver\b/i.test(item.productTitle || '') ? 'spidersaver' : id(item.variantId);
  const recommendations = (cart) => {
    const included = new Set();
    (cart.items || []).forEach((item) => {
      included.add(id(item.variant_id || item.id));
      (item.item_components || []).forEach((component) => {
        included.add(id(component.variant_id || component.id));
      });
    });
    const candidates = new Map();
    (cart.addonVariants || []).forEach((variant) => {
      if (!included.has(id(variant.id))) return;
      const source = (cart.items || []).find((item) => id(item.variant_id || item.id) === id(variant.id)
        || (item.item_components || []).some((component) => id(component.variant_id || component.id) === id(variant.id)));
      const groupId = source?.properties?._marmelade_bundle_id;
      const parent = groupId ? cart.items.find((item) => item.properties?._marmelade_bundle_id === groupId
        && item.properties?._marmelade_bundle_parent === 'true') || source : source;
      const essential = new Set((variant.bundles?.[0]?.contents || []).map((item) => id(item.productId || item.variantId)));
      (variant.bundles || []).forEach((bundle) => {
        (bundle.contents || []).forEach((item) => {
          const variantId = id(item.variantId);
          if (!variantId || essential.has(id(item.productId || item.variantId)) || included.has(variantId)) return;
          const key = recommendationKey(item);
          if (!candidates.has(key)) candidates.set(key, { ...item, sourceVariant: variant, sourceLineKey: parent?.key });
        });
      });
    });
    return Array.from(candidates.values());
  };
  const api = { recommendations };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.MarmeladeCartAddons = api;
})();
